import type {ColumnSet} from 'api/types';

export const mapColumnSetToOption = (columnSet: ColumnSet) => ({
  value: columnSet.id,
  label: columnSet.name,
});
